import { notify } from 'utils/reduxUtils';

export const types = {
  ANALYTICS_AUTHENTICATE_SUCCESS:
    'analytics/dashboardDetails/ANALYTICS_AUTHENTICATE_SUCCESS',
  ANALYTICS_AUTHENTICATE_ERROR:
    'analytics/dashboarDetails/ANALYTICS_AUTHENTICARE_ERROR',
  ANALYTICS_INIT_ERROR: 'analytics/dashboardDetails/ANALYTICS_INIT_ERROR',
  ANALYTICS_INIT_REQUEST: 'analytics/dashboardDetails/ANALYTICS_INIT_REQUEST',
  ANALYTICS_INIT_SUCCESS: 'analytics/dashboardDetails/ANALYTICS_INIT_SUCCESS',
  ADD_DASHBOARD: 'analytics/dashboardDetails/ADD_DASHBOARD',
  INIT_EXPLORE_ERROR: 'analytics/explore/INIT_EXPLORE_ERROR',
  INIT_EXPLORE_REQUEST: 'analytics/explore/INIT_EXPLORE_REQUEST',
  INIT_EXPLORE_SUCCESS: 'analytics/explore/INIT_EXPLORE_SUCCESS',
  SET_SELECTED_DASHBOARD: 'analytics/dashboardDetails/SET_SELECTED_DASHBOARD',
  REMOVE_DASHBOARD: 'analytics/dashboardDetails/REMOVE_DASHBOARD',
  UPDATE_DASHBOARD: 'analytics/dashboardDetails/UPDATE_DASHBOARD',
};

export const setSelectDashboard = ({ dashboardId }) => ({
  type: types.SET_SELECTED_DASHBOARD,
  payload: { dashboardId },
});

export const initAnalytics = {
  error: notify(
    (error) => ({
      type: types.ANALYTICS_INIT_ERROR,
      payload: error,
    }),
    'Failed to initialize analytics',
  ),
  request: () => ({
    type: types.ANALYTICS_INIT_REQUEST,
  }),
  success: ({
    dashboards,
    defaultDashboardId,
    selectedDashboardId,
    timezone,
  }) => ({
    type: types.ANALYTICS_INIT_SUCCESS,
    payload: { dashboards, defaultDashboardId, selectedDashboardId, timezone },
  }),
};

export const initExplore = {
  error: notify((error) => ({
    type: types.INIT_EXPLORE_ERROR,
    payload: error,
  })),
  request: () => ({
    type: types.INIT_EXPLORE_REQUEST,
  }),
  success: ({ queryId, timezone }) => ({
    type: types.INIT_EXPLORE_SUCCESS,
    payload: { queryId, timezone },
  }),
};

export const analyticsAuthenticate = {
  error: notify(
    (error) => ({
      type: types.ANALYTICS_AUTHENTICATE_ERROR,
      payload: error,
    }),
    'Failed to authenticate for analytics',
  ),
  success: ({ authInfo }) => ({
    type: types.ANALYTICS_AUTHENTICATE_SUCCESS,
    payload: { authInfo },
  }),
};

export const addDashboard = ({ dashboard }) => ({
  type: types.ADD_DASHBOARD,
  payload: { dashboard },
});

export const updateDashboard = ({ dashboard }) => ({
  type: types.UPDATE_DASHBOARD,
  payload: { dashboard },
});

export const removeDashboard = ({ dashboardId }) => ({
  type: types.REMOVE_DASHBOARD,
  payload: { dashboardId },
});
